import React from 'react';
import { YesNoToggleButton, ToggleButtonLabelSize } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';

interface DoingAsCompanyFieldProps {
    showCompanyPanel: boolean;
    onToggle: (value: boolean) => void;
}

export const DoingAsCompanyField: React.FC<DoingAsCompanyFieldProps> = ({ showCompanyPanel, onToggle }) => {
    return (
        <YesNoToggleButton
            id='doingAsCompany'
            value={showCompanyPanel}
            onItemClick={(e: ButtonGroupTypes.ItemClickEvent) => onToggle(e.itemData?.id === 'Yes')}
            label='Doing this as a company?'
            labelSize={ToggleButtonLabelSize.Small}
        />
    );
};
